import { normalizeClientList } from "./clientModel";
import { fetchClientsApi } from "./clientService";

const getArrayPayload = (payload) => {
  const candidates = [
    payload?.data?.data,
    payload?.data,
    payload,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) return candidate;
  }

  return [];
};

const getTotalPayload = (payload, fallbackCount) => {
  const candidates = [
    payload?.data?.total,
    payload?.total,
    payload?.data?.count,
    payload?.count,
  ];

  for (const candidate of candidates) {
    if (typeof candidate === "number" && Number.isFinite(candidate)) {
      return candidate;
    }
  }

  return fallbackCount;
};

export const getClientListing = async ({ page, limit, priority, search, sort, folderId }) => {
  const payload = await fetchClientsApi({ page, limit, priority, search, sort, folderId });
  const rawClients = getArrayPayload(payload);
  const clients = normalizeClientList(rawClients);
  const total = getTotalPayload(payload, clients.length);

  return {
    clients,
    total,
  };
};
